import { IScope, IDirective, IAttributes } from "angular";

export interface FileUploadButtonScope extends IScope {
  openFileUpload: () => void;
}

export const vsName = "attachUploadButtonOpener";
export function attachUploadButtonOpenerDirective(): IDirective {
  return {
    scope: false,
    link: {
      post: (scope: IScope, element: JQLite) => {
        const fileInputElement = element.find("input")[0];
        const openFunction = () => {
          fileInputElement.click();
        };
        (<FileUploadButtonScope>scope).openFileUpload = openFunction;
      },
    },
  };
}
